import React, { useContext, useEffect, useState } from "react";
import "./Investments.css";
import { LanguageContext } from "../../context/LanguageContext";

// Images for each investment
import yaqeenImg from "../../assets/yaqeen.jpg";
import nfcImg from "../../assets/nayifat_img.jpg";
import amthalImg from "../../assets/alamthal_img.jpg";

const Investments = () => {
  const { language } = useContext(LanguageContext);  // Get selected language
  const [animateClass, setAnimateClass] = useState("fade-in-page");
  
  // Trigger animation when language changes
  useEffect(() => {
  setAnimateClass("");
  const timeout = setTimeout(() => {
    setAnimateClass("fade-in-page");
  }, 50);

  return () => clearTimeout(timeout); 
  }, [language]);

  // Investment data (shown dynamically based on language)
  const data = [
  {
    id: 1,
    title: language === "ar" ? "يقين المالية" : "Yaqeen Capital",
    ownership: language === "ar" ? "بنسبة 80%" : "Owning 80%",
    description: language === "ar"
      ? "يقين المالية هي شركة مساهمة تأسست في المملكة العربية السعودية بموجب القرار الوزاري رقم 2631 بتاريخ 10 رمضان 1427 هـ (الموافق 3 أكتوبر 2006). تعمل الشركة بموجب سجل تجاري رقم 1010226584 بتاريخ 4 ذو الحجة 1427 هـ (الموافق 25 ديسمبر 2006) في الرياض. تشمل العمليات الرئيسية لشركة يقين المالية خدمات الوساطة والاستشارات الاستثمارية وإدارة الأصول."
      : "Yaqeen Capital a Joint Stock Company, incorporated in the Kingdom of Saudi Arabia was formed pursuant to the ministerial resolution No. 2631 dated 10 Ramadan 1427H (corresponding to October 3, 2006). The Company operates under Commercial Registration No. 1010226584, dated 4 Dhu Al Hijjah 1427H (corresponding to December 25, 2006) in Riyadh. Yaqeen Capital's main operations include brokerage services, investment advisory, and asset management.",
    image: yaqeenImg,
  },
  {
    id: 2,
    title: language === "ar" ? "شركة النايفات للتمويل (NFC)" : "Nayifat Finance Company (“NFC”)",
    ownership: language === "ar" ? "بنسبة 48%" : "Owning 48%",
    description: language === "ar"
      ? "تم تسجيل شركة النايفات للتمويل كشركة مساهمة مقفلة بموجب السجل التجاري رقم 1010176451 الصادر في الرياض بتاريخ 9 جمادى الثاني 1431 هـ (الموافق 23 مايو 2010). وفقًا لقانون الإشراف على شركات التمويل، منحت مؤسسة النقد العربي السعودي (ساما) النايفات ترخيصًا للعمل كشركة تمويل. تشمل عمليات شركة النايفات للتمويل الرئيسية عقد الإيجار التمويلي وتمويل المؤسسات الصغيرة والمتوسطة الحجم وتمويل المستهلك وتمويل بطاقات الائتمان"
      : "NFC was registered as a Closed Joint Stock Company under Commercial Registration (\"CR\") Number 1010176451 issued in Riyadh on 9 Jumad Thani 1431H (corresponding to May 23, 2010). In accordance with the Law of Supervision of Finance Companies, the Saudi Arabian Monetary Authority (SAMA) granted Nayifat a license to operate as a financing company. NFC’s main operations include financing lease, small and medium-sized enterprises financing, consumer financing, and credit card financing.",
    image: nfcImg,
  },
  {
    id: 3,
    title: language === "ar" ? "شركة الأمثل للتمويل" : "Al Amthal Financing Company",
    ownership: language === "ar" ? "بنسبة 45.55%" : "Owning 45.55%",
    description: language === "ar"
      ? "شركة الأمثل للتمويل (\"الشركة\")، هي شركة مساهمة سعودية مقفلة مسجلة في الرياض، المملكة العربية السعودية بموجب سجل تجاري رقم 1010160349 بتاريخ 28 ربيع الثاني 1421 هـ (الموافق 30 يوليو 2000). للشركة فروع في جدة والخبر وأبها. يتم تضمين نتائج وموجودات ومطلوبات هذه الفروع في هذه البيانات المالية المرحلية الموجزة. يقع المكتب المسجل للشركة في مدينة الرياض على العنوان التالي: شركة الأمثل للتمويل ص. 300827 الرياض 11372 المملكة العربية السعودية"
      : "Al Amthal Financing Company is a Saudi closed joint-stock company registered in Riyadh, Kingdom of Saudi Arabia under commercial registration No. 1010160349 dated Rabi Al-Thani 28, 1421H (corresponding to July 30, 2000). The Company has branches in Jeddah, Khobar and Abha. The results, assets, and liabilities of these branches are included in condensed interim financial statements. The registered office of the Company is located in Riyadh.",
    image: amthalImg,
  }
];


  return (
  <div className={`investments-page ${animateClass}`} dir={language === "ar" ? "rtl" : "ltr"}>
      <div className="fade-in-page">

        {/* Page title */}
        <h2 className="investments-title">
          {language === "ar" ? "استثماراتنا" : "Our Investments"}
        </h2>
        <div className="orange-line"></div>

        {/* Investment cards */}
        <div className="investment-cards">
          {data.map((item, index) => (
            <div key={index} className="investment-card">
              {index % 2 === 0 ? (
                <>
                  <div className="image-side">
                    <img src={item.image} alt={item.title} />
                  </div>
                  <div className="text-side dark">
                    <h3>{item.title}</h3>
                    <p className="own">{item.ownership}</p>
                    <p>{item.description}</p>
                  </div>
                </>
              ) : (
                <>
                  <div className="text-side light">
                    <h3>{item.title}</h3>
                    <p className="own">{item.ownership}</p>
                    <p>{item.description}</p>
                  </div>
                  <div className="image-side">
                    <img src={item.image} alt={item.title} />
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Investments;
